module.exports = __webpack_public_path__ + "static/media/nav-arrow-right-white.d049248f.svg";